import { createStore } from "hooksy";

interface State {
  employeeId: any;
}

const defaultValue: State = { employeeId: 0 };

export const [useEmployeeStore] = createStore(defaultValue);
